(function () {
  const initSlider = () => {
    cartSwiper = new Swiper(".upsell-products", {
      slidesPerView: 1,
      spaceBetween: 15,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  };

  initSlider();
  document.addEventListener("shopify:section:load", function () {
    initSlider();
  });
})();

if (!customElements.get("cart-upsell")) {
  customElements.define(
    "cart-upsell",
    class CartForm extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector(".upsell-add-to-cart");
        this.button.addEventListener("click", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          formData.append("id", this.button.dataset.variantId);
          formData.append("quantity", "1");
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "cart-items",
                productVariantId: this.button.dataset.variantId,
                errors: response.description,
                message: response.message,
              });
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "cart-items",
                productVariantId: this.button.dataset.variantId,
              });
            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (event) {
    if (
      event.target.name === "checkout" ||
      event.target.name === "goto_pp" ||
      event.target.name === "goto_gc"
    ) {
      const agreeCheckbox = document.getElementById("terms-field");
      if (agreeCheckbox && agreeCheckbox.checked) {
        event.target.form.submit();
      } else {
        alert(
          "Venligst læs og accepter vores handelsbetingelser for at fortsætte dit køb."
        );
        event.preventDefault();
      }
    }
  });
});
